export const loadImaDaiScript = async () => {
  return new Promise<void>((resolve, reject) => {
    const onError = () => reject(new Error('ima3_dai.js failed to load'));
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://imasdk.googleapis.com/js/sdkloader/ima3_dai.js';
    script.onload = () => {
      if (
        typeof window.google === 'undefined' ||
        !window.google.ima?.dai?.api?.StreamManager
      ) {
        return onError();
      }
      resolve();
    };
    script.onerror = onError;
    document.head.appendChild(script);
  });
};
